// 移除末尾的 |,如果存在的话
const removeTrailingPipe = (text: string) => {
  if (text.trim().endsWith("|")) {
    return text.trim().slice(0, -1)
  }

  return text.trim()
}

function capitalizeFirstLetter(word: string) {
  if (word.length === 0) { return word; } // 如果输入是空字符串，直接返回

  return word.charAt(0).toUpperCase() + word.slice(1);
}

export const getProductFullDetailSeo = ({
  meta_title,
  meta_description,
  meta_keyword,
  defaultColorLabel
}: {
  meta_title: string,
  meta_description: string,
  meta_keyword: string,
  defaultColorLabel: string
}) => {
  let title = meta_title || ""
  let description = (meta_description || "")?.length > 150 
    ? meta_description?.substring(0, 142) + "..."
    : meta_description || ""
  let keywords = meta_keyword || "" 

  title = removeTrailingPipe(title)
  description = removeTrailingPipe(description)
  keywords = removeTrailingPipe(keywords)

  // if (defaultColorLabel) {
  // title = capitalizeFirstLetter(defaultColorLabel) + " " + title
  // description = capitalizeFirstLetter(defaultColorLabel) + " " + description
  // keywords = capitalizeFirstLetter(defaultColorLabel) + " " + keywords
  // }

  return {
    description,
    keywords,
    title
  }
}

export const getNewUrlKey = ({
  colorLabel,
  originalUrlKey,
  packageQuantityLabel,
  searchParamsString,
  hadNoColor
}:{
  colorLabel:string,
  originalUrlKey: string,
  packageQuantityLabel?: string,
  searchParamsString?: string,
  hadNoColor?: boolean
}) => {
  if (hadNoColor) {
    const urlKeyParts = originalUrlKey.split("-");

    const [firstPart, ...restParts] = urlKeyParts
  
    let newUrlKeyParts;
  
    if (packageQuantityLabel) {
      const packageQuantityLabelArray = packageQuantityLabel.split(/[\s-]+/)
      const filterPackageQuantityLabelArray = packageQuantityLabelArray.filter((item: string) => item !== "&")
  
      newUrlKeyParts = [firstPart, ...filterPackageQuantityLabelArray, ...restParts]
    } else {
      newUrlKeyParts = [firstPart, ...restParts]
    }
  
    const nextPathname = `${newUrlKeyParts.join("-")}.html`
  
    return `/${nextPathname}${searchParamsString ? `?${searchParamsString}` : ""}`
  }


  if (!colorLabel) {
    const nextPathname = `${originalUrlKey}.html`;

    return `/${nextPathname}${searchParamsString ? `?${searchParamsString}` : ""}`
  }

  const urlKeyParts = originalUrlKey.split("-");

  const [firstPart, ...restParts] = urlKeyParts

  const colorLabelArray = colorLabel.replaceAll("&", "").split(/[\s-]+/)

  const filterColorLabelArray = colorLabelArray.filter((item: string) => item !== "&")

  let newUrlKeyParts;

  if (packageQuantityLabel) {
    const packageQuantityLabelArray = packageQuantityLabel.split(/[\s-]+/)
    const filterPackageQuantityLabelArray = packageQuantityLabelArray.filter((item: string) => item !== "&")

    newUrlKeyParts = [firstPart, ...filterColorLabelArray, ...filterPackageQuantityLabelArray, ...restParts]
  } else {
    newUrlKeyParts = [firstPart, ...filterColorLabelArray, ...restParts]
  }

  const nextPathname = `${newUrlKeyParts.join("-")}.html`

  return `/${nextPathname}${searchParamsString ? `?${searchParamsString}` : ""}`
}


export const getTitle = ({
  nextState,
  key
}:{
  key: string
  nextState: any
}) => {
  return nextState?.get(key)?.values()?.next()?.value?.title
}


export const getH1Title = ({
  categoryName,

  ky_feeder_type,
  ky_species,
  ky_features,
  ky_mount_type,
  ky_seed_type,
  ky_capacity_filter,
  color,
  price

}:{
  categoryName: string

  ky_feeder_type:string,
  ky_species:string,
  ky_features:string,
  ky_mount_type:string,
  ky_seed_type:string,
  ky_capacity_filter:string,
  color:string,
  price:string,


}) => {
  const titleParts: string[] = [];

  const sizeParts: string[] = [];

  const category = categoryName?.split(" ")

  const first = category?.[0]; // First element
  const others = category?.slice(1); // Remaining elements


  if (first) { titleParts.push(first); }

  if (ky_feeder_type) { titleParts.push(ky_feeder_type); }

  if (ky_species) { titleParts.push(ky_species); }

  if (ky_features) { titleParts.push(ky_features); }

  if (ky_mount_type) { titleParts.push(ky_mount_type); }

  if (ky_seed_type) { titleParts.push(ky_seed_type); }

  if (ky_capacity_filter) { titleParts.push(ky_capacity_filter); }

  if (color) { titleParts.push(color); }

  const h1title = others ? [...titleParts, ...others, ...sizeParts].join(" ") : [...titleParts, ...sizeParts].join(" ");

  return h1title
}

